/**
 * Asynchronously compress a string using the gzip algorithm using the Compression Streams API
 */
export async function gzipCompressString(str: string): Promise<Uint8Array<ArrayBuffer>> {
  // Convert the string to a byte stream.
  const stream = new Blob([str]).stream();

  // Create a compressed stream.
  const compressedStream = stream.pipeThrough(new CompressionStream("gzip"));

  // Read all the bytes from this stream.
  const chunks: any[] = [];
  for await (const chunk of streamAsyncIterator(compressedStream)) {
    chunks.push(chunk);
  }

  return await concatUint8Arrays(chunks);
}

async function* streamAsyncIterator(stream: ReadableStream) {
  // Get a lock on the stream
  const reader = stream.getReader();

  try {
    while (true) {
      // Read from the stream
      const { done, value } = await reader.read();
      // Exit if we're done
      if (done) {
        return;
      }
      // Else yield the chunk
      yield value;
    }
  } finally {
    reader.releaseLock();
  }
}

async function concatUint8Arrays(uint8arrays: Uint8Array<ArrayBuffer>[]): Promise<Uint8Array<ArrayBuffer>> {
  const blob = new Blob(uint8arrays);
  const buffer = await blob.arrayBuffer();
  return new Uint8Array(buffer);
}
